module.exports = __webpack_public_path__ + "static/023-d45ba6e2426c0f49690d3a227de93d8a.png";